

<div class="cart-container">
  <div class="cart-wrapper">
    <div class="cart-content">
      <div class="cart-header" *ngIf="carritoComprasTemp && carritoComprasTemp.length > 0">
        <div class="cart-header-content">
          <div class="cart-header-info">
            <h1 class="cart-title">
              <i class="fas fa-shopping-cart"></i>
              Carrito de Compras
            </h1>

            <!-- Subtítulo con skeleton -->
            <p class="cart-subtitle" *ngIf="!isCalculatingTotal && carritoDetalle?.lista">
              {{ carritoDetalle.lista.length }} producto{{ carritoDetalle.lista.length > 1 ? 's' : '' }} en tu carrito
            </p>
            <p class="cart-subtitle" *ngIf="isCalculatingTotal">
              <span class="skeleton-text subtitle-skeleton"></span>
            </p>

            <!-- Total con skeleton -->
            <div class="cart-header-total">
              <span class="total-label">Total:</span>
              <span class="total-value" *ngIf="!isCalculatingTotal">{{ monedaCarrito }} {{ resumenPedido.totalFinal | number : "1.2-2" }}</span>
              <span class="skeleton-text header-total-skeleton" *ngIf="isCalculatingTotal"></span>
            </div>
          </div>

          <!-- Botón de navegación en el header (solo desktop) -->
          <button
            class="scroll-navigation-btn-header"
            *ngIf="!isCalculatingTotal "
            (click)="toggleScroll()"
            [title]="isScrolledDown ? 'Ir arriba' : 'Ir abajo'">
            <i [class]="isScrolledDown ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
          </button>
        </div>
      </div>

      <!-- Mensaje cuando se está recargando el carrito -->
      <div *ngIf="isCalculatingTotal && (!carritoComprasTemp || carritoComprasTemp.length === 0)" class="updating-cart-container">
        <div class="updating-cart-message">
          <div class="updating-cart-icon">
            <i class="fas fa-sync-alt fa-spin"></i>
          </div>
          <h2 class="updating-cart-title">Actualizando carrito</h2>
          <p class="updating-cart-description">Estamos calculando tu pedido con los descuentos aplicables...</p>
        </div>
      </div>

      <!-- Mensaje cuando el carrito está vacío (no está cargando) -->
      <div *ngIf="!isCalculatingTotal && (!carritoComprasTemp || carritoComprasTemp.length === 0)" class="empty-cart-container">
        <div class="empty-cart-message">
          <div class="empty-cart-icon">
            <i class="fas fa-shopping-cart"></i>
          </div>
          <h2 class="empty-cart-title">Tu carrito está vacío</h2>
          <p class="empty-cart-description">Descubre nuestra colección de fotografías y portadas históricas del Perú</p>
          <div class="empty-cart-actions">
            <a [routerLink]="['/fotografias']" class="btn btn-explore btn-primary">
              <i class="fas fa-camera"></i>
              <span>Explorar Fotografías</span>
            </a>
            <a [routerLink]="['/portadas']" class="btn btn-explore btn-secondary">
              <i class="fas fa-newspaper"></i>
              <span>Explorar Portadas</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Layout del carrito con productos -->
      <div class="cart-layout" *ngIf="carritoComprasTemp && carritoComprasTemp.length > 0">
        <!-- Lista de productos -->
        <div class="cart-items-section">

          <!-- Productos del carrito -->
          <div *ngFor="let libro of carritoComprasTemp; let i = index" class="cart-item">
            <div class="cart-item-content">
              <!-- Imagen del producto -->
              <div class="cart-item-image">
                <div class="image-wrapper">
                  <ng-container *ngIf="!shouldShowSkeleton(libro.activoId)">
                    <img *ngIf="getProtectedImageUrl(libro.activoId)"
                      class="product-image"
                      [src]="getProtectedImageUrl(libro.activoId)"
                      alt="{{ libro.lista[0].title }} - Imagen Protegida"
                    />
                  </ng-container>

                  <!-- Skeleton para portadas: tamaño fijo -->
                  <app-image-skeleton
                    *ngIf="shouldShowSkeleton(libro.activoId) && isPortada(libro)"
                    width="107px"
                    height="160px"
                    size="medium">
                  </app-image-skeleton>

                  <!-- Skeleton para fotografías: tamaño dinámico basado en orientación -->
                  <app-image-skeleton
                    *ngIf="shouldShowSkeleton(libro.activoId) && !isPortada(libro)"
                    [width]="getSkeletonDimensions(libro).width"
                    [height]="getSkeletonDimensions(libro).height"
                    size="medium">
                  </app-image-skeleton>
                </div>
              </div>

              <!-- Información del producto -->
              <div class="cart-item-details">
                <div class="product-header">
                  <span class="item-number">#{{ i + 1 }}</span>
                  <h3 class="product-title">{{ libro.lista[0].title }}</h3>
                </div>

                <p class="product-subtitle" *ngIf="libro.lista[0].subtitle">{{ libro.lista[0].subtitle }}</p>

                <div class="product-specs">
                  <div class="spec-item" *ngIf="libro.lista[0].size?.length > 0">
                    <i class="fas fa-ruler-combined"></i>
                    <span>Talla: {{ libro.lista[0].sizeName }}</span>
                  </div>

                  <div class="spec-item" *ngIf="carritoDetalle.lista[i]?.tipoProducto === '1'">
                    <i class="fas fa-certificate"></i>
                    <span>Modalidad: {{ obtenerModalidad(libro.lista[0], carritoDetalle.lista[i].modalidadId) }}</span>
                  </div>
                </div>

                <!-- Precio -->
                <div class="product-price">
                  <ng-container *ngIf="carritoDetalle.lista[i]?.tipoProducto === '1'">
                    <span class="price-amount">{{ obtenerMoneda(libro.lista[0], carritoDetalle.lista[i].modalidadId) }} {{ obtenerPrecio(libro.lista[0], carritoDetalle.lista[i].modalidadId) }}</span>
                  </ng-container>
                  <ng-container *ngIf="carritoDetalle.lista[i]?.tipoProducto === '2'">
                    <span class="price-amount">S/. {{ libro.lista[0].price }}</span>
                  </ng-container>
                  <span class="price-label">Impuestos incluidos</span>
                </div>

                <!-- Alerta de stock -->
                <div class="stock-alert" *ngIf="carritoDetalle.lista[i]?.cantidad == 0">
                  <i class="fas fa-exclamation-triangle"></i>
                  <span>Producto sin stock</span>
                </div>
              </div>

              <!-- Acciones -->
              <div class="cart-item-actions">
                <button
                  class="btn-remove"
                  (click)="feliminarCarrito(i)"
                  title="Eliminar producto"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Resumen de pago -->
        <div class="cart-summary-section" #cartSummary>
          <div class="cart-summary">
            <div class="summary-header">
              <h3>Resumen del Pedido</h3>
            </div>

            <div class="summary-content">
              <!-- Desglose por grupos -->
              <div class="summary-groups" *ngIf="!isCalculatingTotal && resumenPedido.grupos.length > 0">
                <div class="group-header">
                  <i class="fas fa-layer-group"></i>
                  <span>Detalle por Agrupación</span>
                </div>

                <div class="group-item" *ngFor="let grupo of resumenPedido.grupos">
                  <div class="group-info">
                    <div class="group-title">
                      <span class="group-category">{{ grupo.categoria }}</span>
                      <span class="group-badge">{{ grupo.modalidad }}</span>
                    </div>
                    <div class="group-details">
                      <span class="group-quantity">{{ grupo.cantidad }} {{ grupo.cantidad > 1 ? 'unidades' : 'unidad' }}</span>
                      <span class="group-separator">×</span>
                      <span class="group-unit-price">{{ monedaCarrito }} {{ grupo.precioUnitario | number : "1.2-2" }}</span>
                    </div>
                  </div>
                  <div class="group-pricing">
                    <div class="group-discount" *ngIf="grupo.descuento > 0">
                      <span class="discount-badge">-{{ grupo.porcentajeDescuento }}</span>
                      <span class="discount-amount">-{{ monedaCarrito }} {{ grupo.descuento | number : "1.2-2" }}</span>
                    </div>
                    <div class="group-subtotal">
                      <span class="subtotal-amount">{{ monedaCarrito }} {{ grupo.subtotal | number : "1.2-2" }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Skeleton para el desglose -->
              <div class="summary-groups-skeleton" *ngIf="isCalculatingTotal">
                <div class="skeleton-group-item" *ngFor="let i of [1, 2, 3]">
                  <span class="skeleton-text"></span>
                  <span class="skeleton-text short"></span>
                </div>
              </div>

              <div class="summary-divider"></div>

              <!-- Subtotal sin descuento -->
              <div class="summary-line" *ngIf="!isCalculatingTotal && resumenPedido.totalDescuentos > 0">
                <span class="summary-label">Subtotal sin descuento</span>
                <span class="summary-value">{{ monedaCarrito }} {{ resumenPedido.subtotalSinDescuento | number : "1.2-2" }}</span>
              </div>

              <!-- Total de descuentos -->
              <div class="summary-line discount-line" *ngIf="!isCalculatingTotal && resumenPedido.totalDescuentos > 0">
                <span class="summary-label">
                  <i class="fas fa-tags"></i>
                  Total Descuentos
                </span>
                <span class="summary-value discount-value">-{{ monedaCarrito }} {{ resumenPedido.totalDescuentos | number : "1.2-2" }}</span>
              </div>

              <!-- Impuestos -->
              <div class="summary-line">
                <span class="summary-label">Impuestos (IGV incluido)</span>
                <span class="summary-value">✓</span>
              </div>

              <div class="summary-divider"></div>

              <!-- Total final -->
              <div class="summary-total">
                <span class="total-label">Total a Pagar</span>
                <span class="total-amount" *ngIf="!isCalculatingTotal">{{ monedaCarrito }} {{ resumenPedido.totalFinal | number : "1.2-2" }}</span>
                <span class="skeleton-text total-skeleton" *ngIf="isCalculatingTotal"></span>
              </div>

              <!-- Mensaje de ahorro -->
              <div class="savings-message" *ngIf="!isCalculatingTotal && resumenPedido.totalDescuentos > 0">
                <i class="fas fa-check-circle"></i>
                <span>¡Estás ahorrando {{ monedaCarrito }} {{ resumenPedido.totalDescuentos | number : "1.2-2" }}!</span>
              </div>
            </div>

            <div class="summary-actions">
              <button class="btn-checkout" (click)="procesarPago()" [disabled]="isCalculatingTotal || isProcessingPago">
                <i *ngIf="!isProcessingPago" class="fas fa-lock"></i>
                <i *ngIf="isProcessingPago" class="fas fa-spinner fa-spin"></i>
                <span *ngIf="!isProcessingPago">Proceder al Pago</span>
                <span *ngIf="isProcessingPago">Validando...</span>
              </button>

              <div class="security-info">
                <i class="fas fa-shield-alt"></i>
                <span>Pago 100% seguro</span>
              </div>

              <div class="payment-methods">
                <img src="/assets/image/tarjeta-visa.png" alt="Visa" />
                <img src="/assets/image/tarjeta-mastercard.png" alt="Mastercard" />
                <img src="/assets/image/tarjeta-american.png" alt="American Express" />
                <img src="/assets/image/tarjeta-diners.png" alt="Diners Club" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botón para volver arriba en la parte inferior (solo desktop) -->
      <div class="cart-footer-navigation" *ngIf="carritoComprasTemp && carritoComprasTemp.length > 0 && !isCalculatingTotal">
        <button
          class="scroll-to-top-btn"
          (click)="scrollToTop()"
          title="Volver arriba">
          <i class="fas fa-arrow-up"></i>
          <span>Volver arriba</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Botón flotante para ir al resumen (solo mobile) -->
  <button
    class="scroll-to-summary-btn"
    *ngIf="carritoComprasTemp && carritoComprasTemp.length > 0 && !isCalculatingTotal"
    (click)="scrollToSummary()"
    title="Ver resumen del pedido">
    <i class="fas fa-receipt"></i>
    <span>Ver Resumen</span>
  </button>
</div>
